import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { BillTypeCd } from '@xpo-ltl/sdk-common';
import { Invoice } from '@xpo-ltl/sdk-invoice';

import {
  AccountsReceivableApiService,
  ListArPaymentDetailsByProResp,
  ListArPaymentDetailsByShipmentPath
} from '@xpo-ltl-2.0/sdk-accountsreceivable';

import { ConditioningService } from '@xpo-ltl/common-services';
import { DataOptions } from '@xpo-ltl/data-api';

import { PaymentHistoryData } from '@shared/models/payment-history-data';
import { ChargeToCdPipe } from '@shared/pipes/charge-to-cd/charge-to-cd.pipe';
import { InvoiceAuditorService } from '../invoice-auditor/invoice-auditor.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentHistoryService {

  hasPayments = new BehaviorSubject<boolean>(false);
  paymentHistory = new BehaviorSubject<any>('nothing');
  private paymentHistoryData: PaymentHistoryData = new PaymentHistoryData();

  constructor(
    private datePipe: DatePipe,
    private chargeToCodeTypePipe: ChargeToCdPipe,
    public invoiceService: InvoiceAuditorService,
    private conditioningService: ConditioningService,
    private accountsReceivableApiService: AccountsReceivableApiService,
  ) {}

  getPaymentHistory(userValue: any) {
    userValue = this.conditioningService.conditionProNumber(userValue, 11);

    return this.invoiceService.invoice$.pipe(take(1)).subscribe((response: Invoice) => {
      const shipmentInstId = response && response.invoiceDetail && response.invoiceDetail.shipmentInfo
        ? response.invoiceDetail.shipmentInfo.shipmentInstId
        : undefined;

      this.paymentHistoryData.pickupDate = response.invoiceDetail.shipmentInfo.pickupDate;
      this.paymentHistoryData.custMadCd = response.invoiceClobData.billTo
        ? response.invoiceClobData.billTo.custMadCd
        : '';
        
        const billTypeCd = response.invoiceHeader.billTypeCd !== BillTypeCd.THIRD_PARTY ?
        response.invoiceHeader.billTypeCd :
        this.chargeToCodeTypePipe.transform(response.invoiceHeader.chargeToCd);

      this.getPaymentHistory2(shipmentInstId, billTypeCd);
    });
  }

  getPaymentHistory2(shipmentInstId: number, billTypeCd: string) {
    const dataOptions: DataOptions = {};
    dataOptions.toastOnError = false;
    dataOptions.loadingOverlayEnabled = false;

    const pathParams: ListArPaymentDetailsByShipmentPath = {
      shipmentInstId
    };

    this.accountsReceivableApiService
      .listArPaymentDetailsByShipment(pathParams, dataOptions)
      .pipe(
        take(1),
        catchError(err => throwError(false)),
      )
      .subscribe(
        (response: ListArPaymentDetailsByProResp ) => {
          for (const row of response.arPaymentDetails) {
            row['dateString'] = this.datePipe.transform(row.paymentDate, 'shortDate');
          }
          const filteredPayments = response.arPaymentDetails.filter(payment => {
            return payment.chargeCd.includes(billTypeCd);
          });
          response.arPaymentDetails = filteredPayments;
          this.paymentHistoryData.arrPayDet = response;
          this.hasPayments.next(this.paymentHistoryData.arrPayDet.arPaymentDetails.length > 0);
          this.paymentHistory.next(this.paymentHistoryData);
        },
        (err) => {
          this.hasPayments.next(false);
        }
      );
  }
}
